import { render, staticRenderFns } from "./OcorrenciasNew.vue?vue&type=template&id=f277daf6&scoped=true&"
import script from "./OcorrenciasNew.vue?vue&type=script&lang=js&"
export * from "./OcorrenciasNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f277daf6",
  null
  
)

export default component.exports